export default __webpack_public_path__ + "static/media/image.46fd96a9.svg";